import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Button, Table} from 'antd'
import {QuestionCircleFilled, EyeOutlined, UndoOutlined} from '@ant-design/icons'
import FormModalDescription from './FormModalDescription'
import FormModalDisplay from './FormModalDisplay'
import {toJS} from 'mobx'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

@inject('mappingManagementStore', 'apiManagementStore')
@observer
class FormModal extends Component {
  state = {
    modalVisibleDescription: false,
    modalVisibleDisplay: false,
    record: null
  }
  formRef = React.createRef()

  componentDidMount() {
  }

  /*display Mapping version format(JSON)*/
  handleDisplay = (record) => {
    this.setState({
      modalVisibleDisplay: true,
      record: record
    })
  }
  handleCancelDisplay = () => {
    this.setState({
      modalVisibleDisplay: false
    })
  }
  /*save current version*/
  handleRecord = () => {
    this.setState({
      modalVisibleDescription: true,
    })
  }
  handleCancelDescription = () => {
    this.setState({
      modalVisibleDescription: false
    })
  }
  /*roll back*/
  handleRollback = (value) => {
    const {mappingManagementStore, record, title} = this.props
    confirm({
      title: 'Rollback',
      icon: <QuestionCircleFilled/>,
      content: 'Are you sure to roll back to this version ?',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk() {
        mappingManagementStore.onSaveRollbackAction(record.id, value.name, title, {description: ''})
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {addModalVisible, handleCancel, mappingManagementStore, title, record, t} = this.props
    const {versionList} = mappingManagementStore
    return (
      <>
        <Modal
          title={title === 'MAPPING' ?
            [<p style={{marginBottom: 0}}>{t(`mappingManagement.mappingName`)}: <span style={{fontWeight: 'normal'}}>{record.apiName}</span></p>] :
            [<p style={{marginBottom: 0}}>{t(`mappingManagement.connectName`)}: <span style={{fontWeight: 'normal'}}>{record.apiName}</span></p>]
          }
          // closable={false}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          width="70%"
          centered
          onCancel={handleCancel}
          footer={null}
        >
          <div style={{textAlign: 'right'}}>
            <Button onClick={this.handleRecord} type="primary">{t(`general.record`)}</Button>
          </div>
          <Table dataSource={toJS(versionList)} rowClassName={this.getRowClassName} pagination={false} rowKey="id" scroll={{y: 400}}
                 style={{marginTop: 10}}>
            <Table.Column title={t(`mappingManagement.id`)} dataIndex="name" key="name" ellipsis={true}/>
            <Table.Column title={t(`mappingManagement.date`)} dataIndex="updateTime" key="updateTime" ellipsis={true}/>
            <Table.Column title={t(`mappingManagement.user`)} dataIndex="updateUser" key="updateUser" ellipsis={true}/>
            <Table.Column title={t(`mappingManagement.rollbackId`)} dataIndex="rollbackId" key="rollbackId" ellipsis={true}/>
            <Table.Column title={t(`mappingManagement.description`)} dataIndex="description" key="description" ellipsis={true}/>
            <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
              <>
                <Button onClick={() => this.handleDisplay(record)} type="link" icon={<EyeOutlined/>} title={t(`mappingManagement.display`)}/>
                <Button onClick={() => this.handleRollback(record)} type="link" icon={<UndoOutlined/>} title={t(`mappingManagement.rollback`)}/>
              </>
            )}/>
          </Table>
        </Modal>
        {this.state.modalVisibleDescription ? <FormModalDescription
          addModalVisible={this.state.modalVisibleDescription}
          handleCancel={this.handleCancelDescription}
          record={this.props.record}
          title={this.props.title}
        /> : null}
        {this.state.modalVisibleDisplay ? <FormModalDisplay
          addModalVisible={this.state.modalVisibleDisplay}
          handleCancel={this.handleCancelDisplay}
          record={this.state.record}
          title={this.props.title}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(FormModal)
